export default __webpack_public_path__ + "static/media/Proj1.ef2c3f9b.gif";